export function setSchemaProperty(schemaProperty, viewProperty, { name, title }) {
  schemaProperty.title = viewProperty.title || schemaProperty.title || schemaProperty.name;
  schemaProperty.model = schemaProperty.model || viewProperty.model;
  schemaProperty.type = schemaProperty.type || viewProperty.type;
  schemaProperty.section = { name, title };
  schemaProperty.validators = setValidators(viewProperty);
  schemaProperty.required = getRequired(viewProperty);
}

function getRequired(viewProperty) {
  const { required, min = 0, properties } = viewProperty;
  if (typeof required === 'boolean' || typeof required === 'string') {
    // si es string, es una expresión que respetamos tal cual
    return required;
  }
  const isObjectOrArray = properties?.length;
  if (isObjectOrArray && min > 0) {
    // si es un array, es obligatorio si el `min` es de mas de 0
    return true;
  }
  return false;
}

function setValidators(viewProperty) {
  viewProperty.metadata = viewProperty.metadata || {};
  const validators = {};
  if (viewProperty.required) {
    validators.required = viewProperty.required;
  }
  if (viewProperty.metadata.minLength) {
    validators.minLength = viewProperty.metadata.minLength;
  }
  // @odeniel: el maxlength no se valida ya que no se permite escribir mas caracteres
  if (viewProperty.metadata.maxLength) {
    validators.maxLength = viewProperty.metadata.maxLength;
  }
  if (viewProperty.metadata.min) {
    validators.min = viewProperty.metadata.min;
  }
  if (viewProperty.metadata.max) {
    validators.max = viewProperty.metadata.max;
  }
  if (viewProperty.metadata.decimal) {
    validators.decimal = viewProperty.metadata.decimal;
  }
  if (viewProperty.metadata.fiscalnumber) {
    validators.fiscalnumber = viewProperty.metadata.fiscalnumber;
  }
  if (viewProperty.pattern) {
    validators.pattern = viewProperty.pattern;
  }
  if (viewProperty.type === 'url') {
    validators.url = true;
  }
  if (viewProperty.type === 'email') {
    validators.email = true;
  }
  if (viewProperty.type === 'number') {
    validators.number = true;
  }
  if (viewProperty.type === 'date' || viewProperty.type === 'date-time' || viewProperty.type === 'time') {
    validators.date = true;
  }
  return validators;
}
